import MyProjectsLink from '@components/Header/Desktop/MyProjectsLink';
import LoginBtn from '@components/Header/LoginArea/LoginBtn';
import LogoutBtn from '@components/Header/LoginArea/LogoutBtn';
import ChangeLanguageButton from '@components/Header/Mobile/MainScreenMenuOptions/ChangeLanguageButton';
import ContactSupportLink from '@components/Header/Mobile/MainScreenMenuOptions/ContactSupportLink';
import GoToWixSitesLink from '@components/Header/Mobile/MainScreenMenuOptions/GoToWixSitesLink';
import { IMPHeaderPageName } from '@components/Hooks/useMarketplaceHeaderBi';
import { SetActiveMobileScreenCb } from '../MobileScreens';
import s from '../MobileScreens.module.scss';
import { Box } from '@wix/design-system';

interface Props {
  language: string;
  isUserLoggedIn: boolean;
  marketplaceUrlPrefix: string;
  pageName: string;
  keys: any;
  setActiveScreen: SetActiveMobileScreenCb;
}

const MainScreen = ({
  language,
  isUserLoggedIn,
  marketplaceUrlPrefix,
  pageName,
  keys,
  setActiveScreen,
}: Props) => {
  return (
    <Box direction="vertical">
      {isUserLoggedIn && (
        <>
          <div className={s.linkWrapper} role="listitem">
            <MyProjectsLink
              label={keys.myProjects}
              marketplaceUrlPrefix={marketplaceUrlPrefix}
              pageName={pageName}
            />
          </div>
          <div className={s.divider} />
        </>
      )}
      <div className={s.linkWrapper} role="listitem">
        <ChangeLanguageButton
          language={language}
          setActiveScreen={setActiveScreen}
          pageName={pageName as IMPHeaderPageName}
        />
      </div>
      <div className={s.divider} />
      <div className={s.linkWrapper} role="listitem">
        <ContactSupportLink
          pageName={pageName as IMPHeaderPageName}
          title={keys.contactSupport}
        />
      </div>
      <div className={s.linkWrapper} role="listitem">
        <GoToWixSitesLink
          pageName={pageName as IMPHeaderPageName}
          title={isUserLoggedIn ? keys.wixSites : keys.wix}
        />
      </div>
      <div className={s.mobileMenuStickBottom}>
        <div className={s.topGradient} />
        <div className={s.content}>
          <div className={s.divider} />
          <div className={s.buttons}>
            {isUserLoggedIn ? (
              <LogoutBtn
                btnSize="large"
                btnSkin="standard"
                btnLogoutLabel={keys.btnLogout}
                pageName={pageName}
              />
            ) : (
              <LoginBtn
                btnLoginLabel={keys.btnLogin}
                btnSkin="standard"
                btnSize="large"
                pageName={pageName}
              />
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default MainScreen;
